import { render, staticRenderFns } from "./m_pic_rule.vue?vue&type=template&id=d4951862&scoped=true&"
import script from "./m_pic_rule.vue?vue&type=script&lang=js&"
export * from "./m_pic_rule.vue?vue&type=script&lang=js&"
import style0 from "./m_pic_rule.vue?vue&type=style&index=0&id=d4951862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4951862",
  null
  
)

export default component.exports